export default __webpack_public_path__ + "static/The Adventure_image 3@2x-9e5b0be02e4d1674f61f0aeebf30ec38.jpg";